module.exports = __webpack_public_path__ + "static/media/cross-red.372e7cd3.svg";